<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-layout">
      <div class="md-layout-item md-size-100 pl-0">
        <h1 class="text-xl font-sms">
          {{ $t("zoom_meeting.general_information") }}
        </h1>
      </div>
      <div class="md-layout-item md-size-100">
        <p class="mt-4 break-all">
          {{ $t("zoom_meeting.title") }} :
          <span class="font-sms">{{ general_information.title }}</span>
        </p>
      </div>
      <div class="md-layout-item md-size-40">
        <p class="mt-4">
          {{ $t("communication.send_date_time") }} :
          <span class="font-sms">
            {{ general_information.sent_date_time }}</span
          >
        </p>
      </div>
      <div class="md-layout-item md-size-40">
        <p class="mt-4">
          {{ $t("communication.update_date_time") }} :
          <span class="font-sms">{{
            general_information.updated_date_time
          }}</span>
        </p>
      </div>
      <div class="md-layout-item md-size-20">
        <p class="mt-4 flex justify-end">
          {{ $t("communication.sent") }} :
          <span class="font-sms pl-1">{{ general_information.sent }}</span>
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <p class="mt-4">
          {{ $t("communication.sms_content") }} :
          <span class="font-sms">{{ general_information.content }}</span>
        </p>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout-item md-size-100 pl-0">
        <h1 class="text-xl font-sms mt-4 mb-4">
          {{ $t("communication.message_log") }}
        </h1>
      </div>
      <yv-table
        v-if="tableData.length"
        :tableData="tableData"
        :pagination="pagination"
        :selectedItems="selectedItems"
        @selectItems="onSelectItems"
        :columns="columns"
        selectable="multiple"
        :hideAction="true"
        :hideBulkAction="true"
        :hideNoNumber="true"
        :sort-data="sortData"
        @changePage="changePage"
      />
      <yv-pagination
        v-if="tableData.length"
        :pagination="pagination"
        @changePage="changePage"
        class="my-4"
      />
      <md-card-content v-else>
        <no-data-found></no-data-found>
      </md-card-content>
    </div>
  </div>
</template>

<script>
import { YvTable, YvPagination } from "@/components/Base";
import { service_names } from "@/constants/Services";
import pick from "lodash/pick";
import moment from "moment";
import { formatDateClient } from "../../../../helpers/datetime-helper";
import { Message, getId } from "@/helpers/utils";
import { mapGetters } from "vuex";

export default {
  components: { YvPagination, YvTable },
  data() {
    return {
      general_information: {
        content: null,
        sent: null,
        sent_date_time: null,
        title: null,
        updated_date_time: null
      },
      tableData: [],
      selectedItems: [],
      columns: {
        no: "common.no_number",
        sent_date_time: "communication.send_date_time",
        receiver_info: "communication.receiver_info",
        role_names: "sidebar.role",
        status: "common.status"
      },
      pagination: {
        perPage: 5,
        from: 0,
        hidePerPageOptions: true,
        to: 0,
        total: 0,
        currentPage: 1
      },
      paramsPagination: {
        page: 1,
        limit: 5
      },
      sortData: {
        currentSort: "_id",
        currentSortOrder: "desc"
      },
      idChangePage: null,
      formatDateClient
    };
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone",
      userInfo: "info"
    })
  },
  methods: {
    async getDetailSms(smsId) {
      this.idChangePage = smsId;
      await this.$axios
        .get(
          `${service_names.school}/report-sms/${smsId}`,
          this.paramsPagination
        )
        .then(res => {
          const response = res.data.messaging_logs;
          this.getGeneral(res);
          this.getDate();
          this.pagination = Object.assign(
            this.pagination,
            pick(response, "from", "to", "total")
          );
          this.getTableData(response);
        });
    },
    getGeneral(res) {
      this.general_information = Object.assign(
        this.general_information,
        pick(
          res.data,
          "content",
          "sent",
          "sent_date_time",
          "title",
          "updated_date_time"
        )
      );
    },
    getTableData(response) {
      this.tableData = response.data.map((item, index) => {
        return {
          index,
          ...pick(item, [
            "sent_date_time",
            "receiver_info",
            "role_names",
            "status",
            "user_uuid"
          ])
        };
      });
      this.tableData.forEach(item => {
        let dateFormat = this.convertTimezone(item.sent_date_time, this.userTz);
        item.sent_date_time = moment(dateFormat).format(
          `${formatDateClient} HH:mm:ss`
        );
        item.no = item.index + this.pagination.from;
      });
    },
    formatTime(time, timeZone) {
      const moment = require("moment-timezone");
      return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
        .tz(timeZone)
        .format(`YYYY-MM-DD HH:mm:ss`);
    },
    convertTimezone(time, zone) {
      if (!time) return "";
      return zone
        ? this.formatTime(
            time,
            zone === "UTC" ? this.userInfo.school.timezone : zone
          )
        : this.formatTime(time, this.userInfo.school.timezone);
    },
    formatDateTime(date) {
      let dateFormat = this.convertTimezone(
        moment(date)
          .utcOffset(0)
          .format("YYYY-MM-DD HH:mm:ss"),
        this.userTz
      );
      dateFormat = moment(dateFormat).format(`${formatDateClient} HH:mm:ss`);
      return dateFormat;
    },
    getDate() {
      this.general_information.sent_date_time = this.formatDateTime(
        this.general_information.sent_date_time
      );
      this.general_information.updated_date_time = this.formatDateTime(
        this.general_information.updated_date_time
      );
    },
    changePage() {
      this.paramsPagination.page = this.pagination.currentPage;
      this.getDetailSms(this.idChangePage);
    },
    onSelectItems(userSelected) {
      this.selectedItems = userSelected.map(item => item.user_uuid);
      userSelected.length
        ? this.$emit("disableReSend", false)
        : this.$emit("disableReSend", true);
    },
    async reSendSms() {
      await this.$axios
        .patch(
          `${service_names.school}/sms/${this.idChangePage}`,
          this.selectedItems
        )
        .then(() => {
          Message.success(this.$t("communication.resend_success"));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .isis-selections-box[data-v-fe2ebf94] {
  display: none;
}
.font-sms {
  @apply font-medium text-[#3C4858];
}
</style>
